import { FC, JSX } from "react";

type AppFallbackProps = {
  title: string;
  message?: string;
  showReload?: boolean;
};

/**
 * Theme-independent full-screen fallback. Uses plain markup + inline styles so
 * it renders safely even when there is no `brand` (and therefore no Radix
 * <Theme>) available — e.g. an unknown URL or a crash inside ThemeProvider.
 */
const AppFallback: FC<AppFallbackProps> = ({
  title,
  message,
  showReload,
}): JSX.Element => (
  <div
    style={{
      position: "fixed",
      inset: 0,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "1rem",
      padding: "2rem",
      textAlign: "center",
      background: "#0b0b0f",
      color: "#f5f5f7",
      fontFamily: "system-ui, sans-serif",
    }}
  >
    <h1 style={{ margin: 0, fontSize: "2rem", fontWeight: 700 }}>{title}</h1>
    {message && (
      <p style={{ margin: 0, maxWidth: "40ch", opacity: 0.7 }}>{message}</p>
    )}
    {showReload && (
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          marginTop: "0.5rem",
          padding: "0.6rem 1.4rem",
          borderRadius: "0.5rem",
          border: "1px solid #f5f5f7",
          background: "transparent",
          color: "#f5f5f7",
          fontSize: "1rem",
          cursor: "pointer",
        }}
      >
        Reload
      </button>
    )}
  </div>
);

export default AppFallback;
